import { PointsStrategy } from '@ocx/graphql';
import Achievement from '@ocx/buildtime-retailer-configuration/assets/achievement.svg';
import AgeRestricted from '@ocx/buildtime-retailer-configuration/assets/age-restricted.svg';
import CoinIcon from '@ocx/buildtime-retailer-configuration/assets/coin-icon.svg';
import CoinsIcon from '@ocx/buildtime-retailer-configuration/assets/coins-icon.svg';
import DollarCoinIcon from '@ocx/buildtime-retailer-configuration/assets/dollar-coin-icon.svg';
import DollarsCoinsIcon from '@ocx/buildtime-retailer-configuration/assets/dollars-coins-icon.svg';
import ForceUpgradeBackground from '@ocx/buildtime-retailer-configuration/assets/force-upgrade-background.svg';
import FuelingCompleted from '@ocx/buildtime-retailer-configuration/assets/fueling-completed.svg';
import FuelingProcess from '@ocx/buildtime-retailer-configuration/assets/fueling-process.svg';
import HowDoesItWorkIcon from '@ocx/buildtime-retailer-configuration/assets/how-does-it-work-icon.svg';
import MapMarker from '@ocx/buildtime-retailer-configuration/assets/map-marker.svg';
import Medal from '@ocx/buildtime-retailer-configuration/assets/medal.svg';
import NavLogo from '@ocx/buildtime-retailer-configuration/assets/nav_logo.svg';
import NoData from '@ocx/buildtime-retailer-configuration/assets/no-data.svg';
import UserNotVerifiedIcon from '@ocx/buildtime-retailer-configuration/assets/not-verified.svg';
import PrepaidIcon from '@ocx/buildtime-retailer-configuration/assets/prepaid-card-icon.svg';
import ReadyToUseRewards from '@ocx/buildtime-retailer-configuration/assets/ready-to-use-rewards.svg';
import TotalAvailableRollback from '@ocx/buildtime-retailer-configuration/assets/total-available-rollback.svg';
import UserVerifiedIcon from '@ocx/buildtime-retailer-configuration/assets/verified.svg';
import AmexIcon from '@ocx/ui-icons/assets/amex-icon.svg';
import ApplePayIcon from '@ocx/ui-icons/assets/apple-pay-icon.svg';
import CashIcon from '@ocx/ui-icons/assets/cash-icon.svg';
import DiscoverIcon from '@ocx/ui-icons/assets/discover-icon.svg';
import GeneralCardIcon from '@ocx/ui-icons/assets/general-card-icon.svg';
import GooglePayIcon from '@ocx/ui-icons/assets/google-pay-icon.svg';
import MastercardIcon from '@ocx/ui-icons/assets/mastercard-icon.svg';
import SplitPaymentIcon from '@ocx/ui-icons/assets/multi-payment-icon.svg';
import UnknownPaymentInstrumentIcon from '@ocx/ui-icons/assets/unknown-payment-instrument-icon.svg';
import VisaIcon from '@ocx/ui-icons/assets/visa-icon.svg';

import { AssetKey, LoyaltyCurrencyIconConfig } from './app-config.types';

export const assets: Record<AssetKey, string> = {
  Achievement,
  FuelingCompleted,
  FuelingProcess,
  NavLogo,
  MapMarker,
  HowDoesItWorkIcon,
  UserNotVerifiedIcon,
  UserVerifiedIcon,
  CoinIcon,
  CoinsIcon,
  DollarCoinIcon,
  DollarsCoinsIcon,
  Medal,
  AgeRestricted,
  NoData,
  ReadyToUseRewards,
  TotalAvailableRollback,
  PrepaidIcon,
  ForceUpgradeBackground,
  VisaIcon,
  MastercardIcon,
  DiscoverIcon,
  AmexIcon,
  ApplePayIcon,
  GooglePayIcon,
  GeneralCardIcon,
  SplitPaymentIcon,
  UnknownPaymentInstrumentIcon,
  CashIcon,
};

/**
 * Maps loyalty currency strategy to asset keys for single/multiple display.
 */
export const loyaltyCurrencyAssets = {
  [PointsStrategy.Points]: {
    single: 'CoinIcon',
    multiple: 'CoinsIcon',
  },
  [PointsStrategy.Cents]: {
    single: 'DollarCoinIcon',
    multiple: 'DollarsCoinsIcon',
  },
  [PointsStrategy.NotUsed]: null,
} satisfies Record<PointsStrategy, LoyaltyCurrencyIconConfig | null>;
